/**
 * Request Deduplication Manager
 * Prevents duplicate API calls for the same resource
 */

export class RequestDeduplicator {
  constructor() {
    this.pendingRequests = new Map(); // key -> Promise
  }

  /**
   * Execute request with deduplication
   * @param {string} key - Unique request key
   * @param {Function} requestFunction - Function that returns a Promise
   * @returns {Promise}
   */
  async request(key, requestFunction) {
    // Return existing pending request if available
    if (this.pendingRequests.has(key)) {
      return this.pendingRequests.get(key);
    }

    // Create new request
    const promise = requestFunction()
      .finally(() => {
        // Clean up after completion
        this.pendingRequests.delete(key);
      });

    this.pendingRequests.set(key, promise);
    return promise;
  }

  /**
   * Clear all pending requests
   */
  clear() {
    this.pendingRequests.clear();
  }
}
